<template>
  <div
    class="tw-px-2 tw-py-1 tw-inline-flex tw-border tw-rounded-full tw-font-semibold tw-text-thin"
    :style="{ background: backgroundColour, color: '#ffffff' }"
    data-cy="leave-type-name"
  >
    {{ leaveTypeLabel }}
  </div>
</template>

<script>
export default {
  name: 'LeaveTypeLabel',

  props: {
    leaveType: {
      type: Object,
      required: true,
    },
    isPrivate: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    leaveTypeLabel() {
      if (this.isPrivate) {
        return `${this.leaveType.name} (private)`
      }

      return this.leaveType.name
    },

    backgroundColour() {
      return this.leaveType.colour
    },
  },
}
</script>
